import { FormBuilder, Validators } from '@angular/forms';
import { AvpCustomAdaptor } from './../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { userManagementRoute } from '../../../core/routing/route-names';
import { Router } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ClientAdministrationService } from './client-administration.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ClientAdministrationFormType } from './client-administration-edit-form/client-administration-edit-form';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ClientAdministrationEditFormComponent } from './client-administration-edit-form/client-administration-edit-form.component';

import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';

@Component({
    selector: 'app-client-administration',
    templateUrl: './client-administration.component.html',
    styleUrls: ['./client-administration.component.scss'],
    imports: [SearchFieldComponent, CheckBoxModule, GridModule, ToolbarModule, ClientAdministrationEditFormComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [ClientAdministrationService]
})
export class ClientAdministrationComponent extends GridBaseComponent<ClientAdministrationFormType> implements OnInit {

  constructor(private clientAdministrationService: ClientAdministrationService,
              private router: Router,
              private fb: FormBuilder,
              translateService: TranslateService,
              private spinnerService: SpinnerService) {
    super(null, translateService, clientAdministrationService);
    this.gridCommands = [...GridConstantsFactory.createStandardGridCommands(), {
      type: 'None',
      title: this.translateService.instant('i18n.domain.client-administration.overview.tooltips.add-users'),
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-user--multiple e-icons'
      }
    } as CommandModel];
    this.searchOptions = {fields: ['name', 'address', 'zip', 'city', 'email', 'phoneNumber']};
  }

  public ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.clientAdministrationService, this.spinnerService),
    });
    this.isActiveColumnName = 'isActive';
    this.editDialogTitle = 'i18n.domain.client-administration.overview.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.client-administration.overview.tooltips.add';
  }

  public commandClick(args: CommandClickEventArgs) {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      const clientId = ((args.rowData) as any).id;
      this.router.navigate([userManagementRoute], {queryParams: { clientId }});
    }
  }

  protected override addObjectCompare(addedObject: ClientDTO, rowObject: ClientDTO) : boolean {
    if (this.addIndexFindColumnName) {
      return addedObject.name === rowObject.name && addedObject.address === rowObject.address && addedObject.zip === rowObject.zip;
    }
    return false;
  }

  protected initializeEditForm(data: any): void {
    this.gridEditForm = this.fb.group<ClientAdministrationFormType>({
      id: this.fb.control<number>(data.id),
      name: this.fb.control<string>(data.name, Validators.required),
      address: this.fb.control<string>(data.address),
      zip: this.fb.control<string>(data.zip, [CustomValidatorsFactory.createZipValidator()]),
      city: this.fb.control<string>(data.city),
      email: this.fb.control<string>(data.email, Validators.email),
      phoneNumber: this.fb.control<string>(data.phoneNumber, [CustomValidatorsFactory.createPhoneValidator()]),
      isActive: this.fb.control<boolean>(data.isActive),
    });
  }

  protected getEditDialogTitleParams(rowData: any): object {
    return {param: rowData.name};
  }
}
